import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { AttachmentInfo, ItemInfo, PurchaseDetailInfo, PurchaseInfo, BillInfo} from 'src/app/models/models';
import { Batch_Record, Currency, Currency_Rate, Purchase, Purchase_Detail, Purchase_Detail_Tax, Store, User, Bank_Account, Store_Bank_Account} from 'src/app/models/RestModels';
import { forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import {Utils} from 'src/app/classes/Utils';
import { GetEmpty } from 'src/app/classes/Empties';
import { FacturaMetaData } from 'src/app/classes/FacturaMetaData';

declare function txt2html(str:string):string;
declare function printHtml(html_body:string,title:string):any;

interface CItemAdd
{
	item_info:ItemInfo;
	qty:number;
}

interface CfdiConcepto
{
	descripcion: string;
	cantidad: number;
	valorUnitario: number;
	importe: number;
	descuento: number;
	claveUnidad: string;
	unidad: string;
	matched_item?: ItemInfo;
	search_str?: string;
	// Tax fields
	totalIva: number;          // IVA (Impuesto 002)
	totalIeps: number;         // IEPS (Impuesto 003)
	totalTraslados: number;    // Sum of all transferred taxes (IVA + IEPS + others)
	totalRetenciones: number;  // Sum of ISR and other withheld taxes
	taxes: Purchase_Detail_Tax[];
}

@Component({
	selector: 'app-save-purchase',
	templateUrl: './save-purchase.component.html',
	styleUrls: ['./save-purchase.component.css']
})
export class SavePurchaseComponent extends BaseComponent implements OnInit
{


	show_item_exists_modal: boolean = false;
	item_to_add: ItemInfo | null = null;
	show_change_provider_modal: boolean = false;
	change_provider_search: string = '';
	change_provider_list: User[] = [];

	purchase_info:PurchaseInfo	= this.getEmptyPurchaseInfo();
	item_info_list:ItemInfo[] = [];
	input_search:string = '';
	show_provider_list:boolean = false;
	provider_user_list:User[] = [];
	show_add_new:boolean = false;
	show_new_provider:boolean = false;
	store_list:Store[] = [];
	currency_list:Currency[] = [];
	currency_rate_list:Currency_Rate[] = [];
	item_count:number = 0;
	total_items:number = 0;
	search_str:string = '';

	facturaMetadata:FacturaMetaData = new FacturaMetaData('');

	bank_account_list: Bank_Account[] = [];
	store_bank_account_list: Store_Bank_Account[] = [];
	show_payment_modal: boolean = false;

	// XML Factura properties
	xml_attachment_id: number | null = null;
	cfdi_conceptos: CfdiConcepto[] = [];
	show_cfdi_modal: boolean = false;
	show_xml_provider_modal: boolean = false;
	xml_providers: User[] = [];
	loading_cfdi: boolean = false;
	cfdi_emisor: { rfc: string; nombre: string } = { rfc: '', nombre: '' };
	cfdi_folio: string = '';
	cfdi_fecha: string = '';
	cfdi_total: string = '';

	// Flags to show/hide tax columns based on data presence
	show_iva_column: boolean = false;
	show_ieps_column: boolean = false;
	show_isr_column: boolean = false;

	// Edit price modal
	show_edit_price_modal: boolean = false;
	edit_price_item: PurchaseDetailInfo | null = null;
	edit_price_value: number = 0;

	// Edit qty modal
	show_edit_qty_modal: boolean = false;
	edit_qty_item: PurchaseDetailInfo | null = null;
	edit_qty_value: number = 0;
	edit_qty_original_value: number = 0;

	// Taxes modal
	show_taxes_modal: boolean = false;
	taxes_item: PurchaseDetailInfo | null = null;

	// Batch entry for qty edit
	show_edit_qty_batch_modal: boolean = false;
	edit_qty_batch_rows: { qty: number; batch: string; expiration_date: string }[] = [];
	edit_qty_diff: number = 0;
	edit_qty_is_increase: boolean = true;
	existing_batch_records: Batch_Record[] = [];

	ngOnInit()
	{
		this.sink = this.route.paramMap
		.pipe
		(
			mergeMap((params)=>
			{
				this.is_loading = true;
				this.input_search = '';
				return forkJoin
				({
					stores: this.rest.store.search({limit:9999,sort_order:['name_ASC']}),
					purchase: params.has('id')
						? this.rest.purchase_info.get( params.get('id') )
						: of( this.getEmptyPurchaseInfo() ),
					provider: params.has('provider_id') ? this.rest.user.get( params.get('provider_id') ) : of(null as User),
					currency: this.rest.currency.search({limit:9999,sort_order:['name_ASC']}),
					currency_rate: this.rest.currency_rate.search({limit:9999,sort_order:['currency_id_ASC']}),
					bank_accounts: this.rest.bank_account.search({limit:9999}),
					store_bank_accounts: this.rest.store_bank_account.search({limit:9999}),
				})
			})
		)
		.subscribe
		({
			next:(response)=>
			{
				this.store_list = response.stores.data;
				this.currency_list = response.currency.data;
				this.currency_rate_list = response.currency_rate.data;

				this.bank_account_list = response.bank_accounts.data;
				this.store_bank_account_list = response.store_bank_accounts.data;

				let pi = response.purchase;

				if( pi.bill == null )
				{
					pi.bill = {
						paid_status: 'PENDING',
						total: pi.purchase.total,
						currency_id: 'MXN',
						amount_paid: 0
					};
				}

				if( !pi.details )
				{
					pi.details = [];
				}

				if( !pi.bank_movements_info )
				{
					pi.bank_movements_info = [];
				}

				this.purchase_info = pi;
				if (pi && pi.bill)
				{
					this.xml_attachment_id = pi.bill.pdf_attachment_id || null;
				}

				if( this.purchase_info.purchase.id )
				{
					this.purchase_info.store = this.store_list.find(i=>i.id == this.purchase_info.purchase.store_id) || null
				}
				else if( this.rest.current_user.store_id )
				{
					this.purchase_info.store = this.store_list.find(i=>i.id == this.rest.current_user.store_id) || null;
					this.purchase_info.purchase.store_id = this.rest.current_user.store_id;
				}

				if( response.provider )
				{
					this.userProviderSelected( response.provider );
				}

				this.updateTotal();
				this.is_loading = false;
			},
			error:(error)=>this.showError( error )
		});
	}

	getExchangeRate(currency_id:string):number
	{
		if( this.purchase_info.bill.currency_id == currency_id )
			return 1;

		let store = this.store_list.find((s:Store)=>s.id == this.purchase_info.purchase.store_id) as Store;
		let default_currency_id = store.default_currency_id;

		let currency_rate = this.currency_rate_list.find((r:Currency_Rate)=>
		{
			console.log('COnsole',r);
			if( r.store_id != this.purchase_info.purchase.store_id )
				return false;

			if( this.purchase_info.bill.currency_id == default_currency_id )
			{
				return r.currency_id == currency_id;
			}

			return r.currency_id == this.purchase_info.bill.currency_id;
		});

		if( !currency_rate )
		{

		}

		return default_currency_id == this.purchase_info.bill.currency_id
			? currency_rate.rate
			: 1/currency_rate.rate;
	}

	searchProvider(provider_name:string)
	{
		this.show_provider_list = true;
		this.purchase_info.purchase.provider_name = provider_name;
		this.purchase_info.purchase.provider_user_id = null;

		this.subs.sink = this.rest.user.search(
		{
			start:{	name:provider_name },
			eq:{ status:'ACTIVE'},
			search_extra:{'user_permission.is_provider':1},
			limit: 20
		})
		.subscribe((response)=>
		{
			this.provider_user_list = response.data;
		});
	}

	addNewProvider(provider_name: string)
	{
		this.is_loading = true;
		this.show_provider_list = false;

		let user: Partial<User> = {
			name: provider_name,
			email: provider_name,
			store_id: undefined,
			type: 'USER',
			credit_days: 0,
			credit_limit: 0,
			price_type_id: undefined,
		};

		let user_permission = GetEmpty.user_permission();
		user_permission.is_provider = 1;

		this.subs.sink = this.rest.user
		.create(user).pipe
		(
			mergeMap((response)=>
			{
				user_permission.user_id = response.id;
				this.purchase_info.purchase.provider_user_id = response.id;
				this.purchase_info.bill.provider_user_id = response.id;

				return this.rest.user_permission.update(user_permission);
			})
		)
		.subscribe
		({
			next: (response)=>
			{
				this.is_loading = false;
				this.showSuccess('Se agregó un nuevo proveedor');
				this.provider_user_list = [];
			},
			error: (error)=>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	userProviderSelected(user:User)
	{
		this.show_provider_list = false;
		this.purchase_info.purchase.provider_name = user.name;
		this.purchase_info.purchase.provider_user_id = user.id;
		this.purchase_info.bill.provider_user_id = user.id;
		this.provider_user_list = [];
	}

	getEmptyPurchaseInfo():PurchaseInfo
	{
		let purchase:Purchase = {
			stock_status: 'PENDING',
			order_id: null,
			store_id: this.rest?.current_user?.store_id	|| 0,
			created: new Date(),
			updated: new Date(),
			created_by_user_id: this.rest?.current_user?.id || 0,
			provider_name: '',
			status: 'ACTIVE',
			provider_user_id: null,
			updated_by_user_id: null,
			total: 0,
			id: 0,
		};

		let p:PurchaseInfo = {
			purchase,
			bill: {
				paid_status: 'PENDING',
				currency_id: 'MXN',
				amount_paid: 0,
				total: 0
			},
			details:[] as PurchaseDetailInfo[],
			shipping: null,
			bank_movements_info: [],
		};

		return p;
	}

	save()
	{
		this.is_loading = true;
		if (this.purchase_info && this.purchase_info.bill)
		{
			this.purchase_info.bill.pdf_attachment_id = this.xml_attachment_id;
		}

		if( this.purchase_info.purchase.id	)
		{
			this.purchase_info.purchase.total =this.purchase_info.bill.total;

			this.subs.sink = this.rest.purchase_info.update( this.purchase_info )
			.subscribe
			({
				next: (purchase)=>
				{
					this.finishSave(purchase);
				},
				error: (error)=>
				{
					this.is_loading = false;
					this.showError(error);
				}
			});
		}
		else
		{
			this.purchase_info.purchase.total =this.purchase_info.bill.total;

			if( !this.rest.current_permission.global_purchases )
			{
				this.purchase_info.purchase.store_id = this.rest.current_user.store_id;
			}

			if (!this.purchase_info.purchase.provider_user_id)
			{
				this.is_loading = false;
				this.showError('Debe seleccionar un proveedor existente de la lista o registrar uno nuevo');
				return;
			}

			this.subs.sink = this.rest.purchase_info.create(this.purchase_info)
			.subscribe
			({
				next: (purchase)=>
				{
					this.finishSave(purchase);
				},
				error: (error)=>
				{
					this.is_loading = false;
					this.showError(error);
				}
			});
		}
	}

	finishSave(purchase?: PurchaseInfo)
	{
		this.is_loading = false;
		if (purchase)
		{
			this.purchase_info = purchase;
		}
		this.showSuccess('Orden de compra guardada');
	}

	onPaymentCreated()
	{
		this.show_payment_modal = false;
		window.location.reload();
	}

	billAsList(): BillInfo[]
	{
		if (!this.purchase_info || !this.purchase_info.bill) return [];
		return [{
			bill: this.purchase_info.bill,
			provider: this.purchase_info.provider || null,
			store: this.purchase_info.store || null,
			bank_account: null,
			invoice_attachment: null,
			receipt_attachment: null,
			pdf_attachment: null,
			invoice_file_type: null,
			bank_movements_info: [],
			paid_by_user: null,
			approved_by_user: null,
		} as any];
	}

	onInput(evt:Event)
	{
		if( evt.target['value'] == '' )
		{
			this.item_info_list = [];
			return;
		}

		let input = evt.target as HTMLInputElement;
		this.subs.sink = this.rest.item_info.search({
			eq:{status:'ACTIVE'},
			search_extra:{category_name:input.value}
		})
		.subscribe((response)=>
		{
			this.item_info_list = response.data;
		});
	}

	onItemInfoSelect(item_info:ItemInfo, qty:number=1)
	{
		console.log('Item ifno has', item_info.item );
		if( this.purchase_info.details.some((i)=>i.purchase_detail.item_id == item_info.item.id && item_info.item.has_serial_number == "NO") )
		{
			this.item_to_add = item_info;
			this.show_item_exists_modal = true;
			return;
		}

		this.show_add_new = false;

		this.item_info_list = [];

		let purchase_detail:Purchase_Detail = {
			purchase_id: this.purchase_info.purchase.id,
			item_id	:	item_info.item.id,
			status: 'ACTIVE',
			qty: qty,
			stock_status: 'PENDING',
			description: '',
			discount: 0,
			id: 0,
			total: 0,
			serial_number: item_info.item.has_serial_number == 'YES' ? '' : null,
			created: new Date(),
			updated: new Date(),
			unitary_price: ( item_info.item.reference_price || 0.0 ) * this.getExchangeRate( item_info.item.reference_currency_id )
		};

		this.purchase_info.details.push
		({
			purchase_detail: purchase_detail,
			item: item_info.item,
			category: item_info.category,
			taxes: []
		})

		this.updateTotal();

		this.input_search = '';
	}

	incrementExistingItem()
	{
		let existing_item = this.purchase_info.details.find(i => i.item.id === this.item_to_add.item.id);
		existing_item.purchase_detail.qty++;
		this.updateTotal();
		this.show_item_exists_modal = false;
		this.item_to_add = null;
	}

	cancelAddExistingItem()
	{
		this.show_item_exists_modal = false;
		this.item_to_add = null;
	}

	onItemScannedAdd(item_add:CItemAdd)
	{
		let purchase_detail = this.purchase_info.details.find(i=>i.purchase_detail.item_id == item_add.item_info.item.id);

		if( purchase_detail )
		{
			purchase_detail.purchase_detail.qty += item_add.qty;
		}
		else
		{
			this.onItemInfoSelect(item_add.item_info, item_add.qty);
		}

		this.updateTotal();
	}



	updateTotal()
	{
		this.purchase_info.purchase.total = this.purchase_info.details.reduce((prev, pi) => {
			if (pi.purchase_detail.status === 'DELETED') return prev;
			
			let subtotal = (pi.purchase_detail.unitary_price || 0) * (pi.purchase_detail.qty || 0);
			let discount = pi.purchase_detail.discount || 0;
			let taxes = this.getTaxesTotal(pi);
			return prev + (subtotal - discount) + taxes;
		}, 0);

		this.total_items = this.purchase_info.details.reduce((prev, pi) => {
			return pi.purchase_detail.status === 'DELETED' ? prev : prev + pi.purchase_detail.qty;
		}, 0);

		this.purchase_info.bill.total = Math.round(this.purchase_info.purchase.total * 100) / 100;
	}

	removeItem(pid:PurchaseDetailInfo)
	{
		if( !pid.purchase_detail.id )
		{
			let index = this.purchase_info.details.findIndex(i=>i===pid);
			if( index > -1 )
				this.purchase_info.details.splice(index,1);
		}
		else
		{
			pid.purchase_detail.status = 'DELETED';
		}
	}
	showAddNewItem()
	{
		this.search_str = '';
		this.show_add_new = true;
	}

	openPaymentModal()
	{
		this.show_payment_modal = true;
	}

	print(evt:Event)
	{
		let store = this.store_list.find(i=>this.purchase_info.purchase.store_id == i.id);
		let store_name = txt2html(store?.name || '');
		let html = `
			<h1>Orden de compra ${this.purchase_info.purchase.id}</h1>
			<div>
				Proveedor:<b>${txt2html(this.purchase_info.purchase.provider_name)}</b>
			</div>
			<div>
				Sucursal:<b>${store_name}</b>
			</div>
			<div>
				Fecha:<b>${this.purchase_info.purchase.created.toLocaleString()}</b>
			</div>
			<table style="width:100%">
				<thead>
					<tr>
						<th style="text-align:left;">Articulo</th>
						<th style="text-align:right;">Cantidad</th>
						<th style="text-align:right;">Total</th>
					</tr>
				</thead>
				<tbody>
		`;

		let total = 0;
		let total_items = 0;

		this.purchase_info.details.forEach((di)=>
		{
			let cname = '';

			if( di.category && this.rest.local_preferences.display_categories_on_items == 'YES' )
				cname = di.category.name+' - ';

			total += di.purchase_detail.qty*di.purchase_detail.unitary_price;
			total_items += di.purchase_detail.qty;

			let ciname = txt2html( cname+' '+di.item.name );

			html += `<tr>
				<td style="text-align:left;">${ciname}</td>
				<td style="text-align:right;">${this.formatNumber( di.purchase_detail.qty)}</td>
				<td style="text-align:right;">${this.formatCurrency( di.purchase_detail.qty*di.purchase_detail.unitary_price) }</td>
			</tr>`;
		});

		html += `
			<tr>
				<td style="text-align:right;"><b>Total</b></td>
				<td style="text-align:right;"><b>${this.formatNumber(total_items)}</b></td>
				<td style="text-align:right;"><b>${this.formatCurrency(total)}</b></td>
			</tr>
		`;

		html += '</tbody></table>';

		//console.log( 'html is ', html);

		printHtml( html, 'purchase' );
	}
	currency_formater = new Intl.NumberFormat('us-EN', { style: 'currency', currency: 'USD', currencyDisplay:"narrowSymbol" });
	number_formater = new Intl.NumberFormat('us-EN', { maximumSignificantDigits: 2,} ); // useGrouping:"always"

	formatCurrency(amount:number):string
	{
		return this.currency_formater.format(amount);
	}
	formatNumber(amount:number):string
	{
		return this.number_formater.format(amount);
	}
	clone(pdi:PurchaseDetailInfo)
	{
		let purchase_detail = {...pdi.purchase_detail };
		purchase_detail.serial_number = '';
		purchase_detail.id = 0;

		this.purchase_info.details.push({
			purchase_detail,
			item:pdi.item,
			category:pdi.category,
			taxes: pdi.taxes ? [...pdi.taxes] : []
		})
	}

	closeScannerDialog()
	{
		let dialog = document.getElementById('scanner_dialog') as HTMLDialogElement;
		dialog.close();
	}

	showScanner()
	{
		let dialog = document.getElementById('scanner_dialog') as HTMLDialogElement;
		dialog.showModal();
	}

	onNoResultsFound(barcode: string)
	{
		this.search_str = barcode;
		this.showAddNewItem();
	}

	onXmlAttachmentChange(attachment_info: AttachmentInfo)
	{
		this.xml_attachment_id = attachment_info.attachment.id;
		this.loadAndParseXml();
	}

	loadAndParseXml()
	{
		if (!this.xml_attachment_id) return;

		this.loading_cfdi = true;
		let url = this.rest.getFilePath(this.xml_attachment_id, false);

		fetch(url)
		.then(response => response.text())
		.then(data => {
			this.cfdi_conceptos = this.parseConceptosFromXml(data);
			this.updateTaxColumnFlags();
			this.matchConceptosWithItems();
		})
		.catch(error => {
			console.error('Error al cargar el archivo XML', error);
			this.showError('Error al cargar el archivo XML');
			this.loading_cfdi = false;
		});
	}

	parseConceptosFromXml(data: string): CfdiConcepto[]
	{
		const parser = new DOMParser();
		const dom: XMLDocument = parser.parseFromString(data, "application/xml");
		let conceptos: CfdiConcepto[] = [];

		const getByTag = (el: Element | Document, tag: string) => {
			let result = el.getElementsByTagName("cfdi:" + tag);
			if (result.length === 0) {
				result = el.getElementsByTagName(tag);
			}
			return result;
		};

		// Extract Comprobante attributes
		let comprobante = getByTag(dom, "Comprobante");
		if (comprobante.length > 0)
		{
			let comp = comprobante.item(0) as Element;
			this.cfdi_folio = comp.getAttribute('Folio') || '';
			this.cfdi_fecha = comp.getAttribute('Fecha') || '';
			this.cfdi_total = comp.getAttribute('Total') || '';
		}

		// Extract Emisor (provider) information
		let emisorElements = getByTag(dom, "Emisor");
		if (emisorElements.length > 0)
		{
			let emisor = emisorElements.item(0) as Element;
			this.cfdi_emisor = {
				rfc: emisor.getAttribute('Rfc') || '',
				nombre: emisor.getAttribute('Nombre') || ''
			};
		}

		// Extract Conceptos
		let conceptosElements = getByTag(dom, "Concepto");

		for (let i = 0; i < conceptosElements.length; i++)
		{
			let element = conceptosElements.item(i) as Element;
			let descripcion = element.getAttribute('Descripcion') || '';
			let importeConcepto = parseFloat(element.getAttribute('Importe') || '0');
			let descuentoConcepto = parseFloat(element.getAttribute('Descuento') || '0');
			let cantidadConcepto = parseFloat(element.getAttribute('Cantidad') || '0');
			let valorUnitarioConcepto = parseFloat(element.getAttribute('ValorUnitario') || '0');

			// Extract taxes from nested elements
			let totalIva = 0;
			let totalIeps = 0;
			let totalTraslados = 0;
			let totalRetenciones = 0;
			let detail_taxes: Purchase_Detail_Tax[] = [];

			// Get cfdi:Impuestos child element
			let impuestosElements = getByTag(element, "Impuestos");
			if (impuestosElements.length > 0)
			{
				let impuestos = impuestosElements.item(0) as Element;

				// Sum Traslado imports by type (002=IVA, 003=IEPS)
				let trasladoElements = getByTag(impuestos, "Traslado");
				for (let j = 0; j < trasladoElements.length; j++)
				{
					let traslado = trasladoElements.item(j) as Element;
					let importe = parseFloat(traslado.getAttribute('Importe') || '0');
					let impuesto = traslado.getAttribute('Impuesto') || '';
					let base = parseFloat(traslado.getAttribute('Base') || '0');
					let rate = parseFloat(traslado.getAttribute('TasaOCuota') || '0');
					let tipoFactor = traslado.getAttribute('TipoFactor') || '';

					if (impuesto === '002') {
						totalIva += importe;
					} else if (impuesto === '003') {
						totalIeps += importe;
					}
					totalTraslados += importe;

					let taxName = 'TRASLADO';
					if (impuesto === '002') taxName = `IVA ${rate * 100}%`;
					else if (impuesto === '003') taxName = `IEPS ${rate * 100}%`;

					detail_taxes.push({
						id: 0,
						purchase_detail_id: 0,
						amount: importe,
						base: base,
						code: impuesto,
						is_retention: 0,
						name: taxName,
						rate: rate,
						type: tipoFactor === 'Tasa' ? 'rate' : (tipoFactor === 'Cuota' ? 'fixed' : 'exempt'),
						created: new Date()
					});
				}

				// Sum all Retencion imports (ISR, etc.)
				let retencionElements = getByTag(impuestos, "Retencion");
				for (let j = 0; j < retencionElements.length; j++)
				{
					let retencion = retencionElements.item(j) as Element;
					let importe = parseFloat(retencion.getAttribute('Importe') || '0');
					let impuesto = retencion.getAttribute('Impuesto') || '';
					let base = parseFloat(retencion.getAttribute('Base') || '0');
					let rate = parseFloat(retencion.getAttribute('TasaOCuota') || '0');
					let tipoFactor = retencion.getAttribute('TipoFactor') || '';

					totalRetenciones += importe;

					let taxName = 'RETENCION';
					if (impuesto === '001') taxName = `ISR ${rate * 100}%`;
					else if (impuesto === '002') taxName = `IVA ${rate * 100}%`;

					detail_taxes.push({
						id: 0,
						purchase_detail_id: 0,
						amount: importe,
						base: base,
						code: impuesto,
						is_retention: 1,
						name: taxName,
						rate: rate,
						type: tipoFactor === 'Tasa' ? 'rate' : (tipoFactor === 'Cuota' ? 'fixed' : 'exempt'),
						created: new Date()
					});
				}
			}

			conceptos.push({
				descripcion: descripcion,
				cantidad: cantidadConcepto,
				valorUnitario: valorUnitarioConcepto,
				importe: importeConcepto - descuentoConcepto,
				descuento: descuentoConcepto,
				claveUnidad: element.getAttribute('ClaveUnidad') || '',
				unidad: element.getAttribute('Unidad') || '',
				search_str: '',
				totalIva: totalIva,
				totalIeps: totalIeps,
				totalTraslados: totalTraslados,
				totalRetenciones: totalRetenciones,
				taxes: detail_taxes
			});
		}

		return conceptos;
	}

	updateTaxColumnFlags()
	{
		this.show_iva_column = this.cfdi_conceptos.some(c => c.totalIva > 0);
		this.show_ieps_column = this.cfdi_conceptos.some(c => c.totalIeps > 0);
		this.show_isr_column = this.cfdi_conceptos.some(c => c.totalRetenciones > 0);
	}

	matchConceptosWithItems()
	{
		if (this.cfdi_conceptos.length === 0)
		{
			this.loading_cfdi = false;
			this.showError('No se encontraron conceptos en el XML');
			return;
		}

		// Search for provider by RFC using the address endpoint, then by name
		let providerPromise = this.cfdi_emisor.rfc
			? this.rest.address.search({
				eq: { rfc: this.cfdi_emisor.rfc, status: 'ACTIVE' },
				limit: 10
			}).pipe(
				mergeMap(addressResult => {
					if (addressResult.data.length > 0)
					{
						let userIds = addressResult.data.map(a => a.user_id).filter(id => id);
						if (userIds.length > 0)
						{
							return this.rest.user.search({
								csv: { id: userIds },
								eq: { status: 'ACTIVE' },
								search_extra: { 'user_permission.is_provider': 1 }
							});
						}
					}
					// Fallback to name search if no RFC match
					return this.cfdi_emisor.nombre
						? this.rest.user.search({
							lk: { name: this.cfdi_emisor.nombre },
							eq: { status: 'ACTIVE' },
							search_extra: { 'user_permission.is_provider': 1 },
							limit: 10
						})
						: of({ data: [] });
				})
			).toPromise()
			: this.cfdi_emisor.nombre
				? this.rest.user.search({
					lk: { name: this.cfdi_emisor.nombre },
					eq: { status: 'ACTIVE' },
					search_extra: { 'user_permission.is_provider': 1 },
					limit: 10
				}).toPromise()
				: Promise.resolve({ data: [] });

		let searchPromises = this.cfdi_conceptos.map(concepto => {
			return this.rest.item_info.search({
				lk: { name: concepto.descripcion },
				eq: { status: 'ACTIVE' },
				limit: 1
			}).toPromise();
		});

		Promise.all([providerPromise, ...searchPromises])
		.then(results => {
			// First result is the provider search
			let providerResult = results[0];
			this.xml_providers = providerResult.data;
			this.show_xml_provider_modal = true;

			// Set folio from XML
			if (this.cfdi_folio)
			{
				this.purchase_info.bill.folio = this.cfdi_folio;
			}

			// Rest of results are item searches
			results.slice(1).forEach((response, index) => {
				if (response.data.length > 0)
				{
					this.cfdi_conceptos[index].matched_item = response.data[0];
				}
			});
			this.loading_cfdi = false;
			this.show_cfdi_modal = true;
		})
		.catch(error => {
			console.error('Error al buscar artículos', error);
			this.showError('Error al buscar artículos coincidentes');
			this.loading_cfdi = false;
		});
	}

	selectXmlProvider(user: User)
	{
		this.userProviderSelected(user);
		this.show_xml_provider_modal = false;
	}

	addNewProviderFromXml()
	{
		this.addNewProvider(this.cfdi_emisor.nombre);
		this.show_xml_provider_modal = false;
	}

	quickSaveProvider()
	{
		this.is_loading = true;
		let user: any = {
			name: this.cfdi_emisor.nombre,
			type: 'USER',
			status: 'ACTIVE',
			username: this.cfdi_emisor.rfc || this.cfdi_emisor.nombre,
			credit_days: 0,
			credit_limit: 0
		};

		this.subs.sink = this.rest.user.create(user).pipe(
			mergeMap((newUser: User) => {
				let permission = GetEmpty.user_permission();
				permission.user_id = newUser.id;
				permission.is_provider = 1;
				
				// Create address with RFC
				let address: any = {
					user_id: newUser.id,
					name: newUser.name,
					rfc: this.cfdi_emisor.rfc,
					status: 'ACTIVE',
					type: 'BILLING'
				};

				return forkJoin({
					permission: this.rest.user_permission.update(permission),
					address: this.rest.address.create(address)
				}).pipe(
					mergeMap(() => of(newUser))
				);
			})
		).subscribe({
			next: (newUser) => {
				this.is_loading = false;
				this.selectXmlProvider(newUser);
				this.showSuccess('Proveedor registrado y seleccionado');
			},
			error: (error) => {
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	searchItemForConcepto(concepto: CfdiConcepto, search_term: string)
	{
		this.subs.sink = this.rest.item_info.search({
			lk: { name: search_term },
			eq: { status: 'ACTIVE' },
			limit: 10
		}).subscribe({
			next: (response) => {
				if (response.data.length > 0)
				{
					concepto.matched_item = response.data[0];
				}
			},
			error: (error) => this.showError(error)
		});
	}

	addConceptosToPurchase()
	{
		let added_count = 0;

		this.cfdi_conceptos.forEach(concepto => {
			if (concepto.matched_item)
			{
				let purchase_detail: Purchase_Detail = {
					purchase_id: this.purchase_info.purchase.id,
					item_id: concepto.matched_item.item.id,
					status: 'ACTIVE',
					qty: concepto.cantidad,
					stock_status: 'PENDING',
					description: concepto.descripcion,
					discount: concepto.descuento || 0,
					id: 0,
					total: concepto.importe, // Matches qty * unitary_price before discount
					serial_number: concepto.matched_item.item.has_serial_number === 'YES' ? '' : null,
					created: new Date(),
					updated: new Date(),
					unitary_price: concepto.valorUnitario * this.getExchangeRate(concepto.matched_item.item.reference_currency_id)
				};

				this.purchase_info.details.push({
					purchase_detail: purchase_detail,
					item: concepto.matched_item.item,
					category: concepto.matched_item.category,
					taxes: concepto.taxes
				});
				added_count++;
			}
		});

		this.updateTotal();
		this.show_cfdi_modal = false;
		this.showSuccess(`Se agregaron ${added_count} artículos de la factura`);
	}

	clearConceptoMatch(concepto: CfdiConcepto)
	{
		concepto.matched_item = undefined;
		concepto.search_str = '';
	}

	selectItemForConcepto(concepto: CfdiConcepto, item_info: ItemInfo)
	{
		concepto.matched_item = item_info;
		concepto.search_str = '';
	}

	getMatchedConceptosCount(): number
	{
		return this.cfdi_conceptos.filter(c => c.matched_item).length;
	}

	getUnmatchedConceptosCount(): number
	{
		return this.cfdi_conceptos.filter(c => !c.matched_item).length;
	}

	getCfdiTotalCantidad(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.cantidad, 0);
	}

	getCfdiTotalImporte(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.importe, 0);
	}

	getCfdiTotalIva(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalIva, 0);
	}

	getCfdiTotalIeps(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalIeps, 0);
	}

	getCfdiTotalTraslados(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalTraslados, 0);
	}

	getCfdiTotalRetenciones(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.totalRetenciones, 0);
	}

	getCfdiTotalConImpuestos(): number
	{
		return this.cfdi_conceptos.reduce((sum, c) => sum + c.importe + c.totalTraslados - c.totalRetenciones, 0);
	}

	isCfdiTotalMatch(): boolean
	{
		let xmlTotal = parseFloat(this.cfdi_total) || 0;
		let calculatedTotal = this.getCfdiTotalConImpuestos();
		return Math.abs(xmlTotal - calculatedTotal) < 0.01;
	}

	showChangeProviderModal()
	{
		this.change_provider_search = '';
		this.change_provider_list = [];
		this.show_change_provider_modal = true;
	}

	searchProviderInModal(provider_name: string)
	{
		if (!provider_name || provider_name.length < 2) {
			this.change_provider_list = [];
			return;
		}

		this.subs.sink = this.rest.user.search({
			start: { name: provider_name },
			eq: { status: 'ACTIVE' },
			search_extra: { 'user_permission.is_provider': 1 },
			limit: 20
		}).subscribe({
			next: (response) => {
				this.change_provider_list = response.data;
			},
			error: (error) => this.showError(error)
		});
	}

	selectProviderFromModal(user: User)
	{
		this.is_loading = true;

		this.subs.sink = this.rest.updatePath('change_purchase_provider', {
			purchase_id: this.purchase_info.purchase.id,
			provider_user_id: user.id
		}).subscribe({
			next: () => {
				this.purchase_info.purchase.provider_name = user.name;
				this.purchase_info.purchase.provider_user_id = user.id;
				this.purchase_info.bill.provider_user_id = user.id;
				this.show_change_provider_modal = false;
				this.change_provider_list = [];
				this.change_provider_search = '';
				this.is_loading = false;
				this.showSuccess('Proveedor actualizado correctamente');
			},
			error: (error) => {
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	addNewProviderFromModal(provider_name: string)
	{
		this.is_loading = true;

		let user: Partial<User> = {
			name: provider_name,
			email: provider_name,
			store_id: undefined,
			type: 'USER',
			credit_days: 0,
			credit_limit: 0,
			price_type_id: undefined,
		};

		let user_permission = GetEmpty.user_permission();
		user_permission.is_provider = 1;

		this.subs.sink = this.rest.user
		.create(user).pipe
		(
			mergeMap((response) =>
			{
				user_permission.user_id = response.id;
				return this.rest.user_permission.update(user_permission).pipe
				(
					mergeMap(() =>
					{
						return this.rest.updatePath('change_purchase_provider', {
							purchase_id: this.purchase_info.purchase.id,
							provider_user_id: response.id
						}).pipe
						(
							mergeMap(() => of({ id: response.id, name: provider_name }))
						);
					})
				);
			})
		)
		.subscribe({
			next: (result) =>
			{
				this.purchase_info.purchase.provider_name = result.name;
				this.purchase_info.purchase.provider_user_id = result.id;
				this.purchase_info.bill.provider_user_id = result.id;
				this.show_change_provider_modal = false;
				this.change_provider_list = [];
				this.change_provider_search = '';
				this.is_loading = false;
				this.showSuccess('Proveedor registrado y asignado correctamente');
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	showTaxesModal(pdi: PurchaseDetailInfo)
	{
		this.taxes_item = pdi;
		if (!this.taxes_item.taxes)
		{
			this.taxes_item.taxes = [];
		}
		this.show_taxes_modal = true;
	}

	addTax()
	{
		if (!this.taxes_item) return;

		this.taxes_item.taxes.push({
			id: 0,
			purchase_detail_id: this.taxes_item.purchase_detail.id || 0,
			amount: 0,
			base: 0,
			code: '',
			is_retention: 0,
			name: '',
			rate: 0,
			type: 'rate',
			created: new Date()
		});
	}

	addIva16()
	{
		if (!this.taxes_item) return;
		
		let base = this.taxes_item.purchase_detail.unitary_price * this.taxes_item.purchase_detail.qty;
		
		this.taxes_item.taxes.push({
			id: 0,
			purchase_detail_id: this.taxes_item.purchase_detail.id || 0,
			amount: base * 0.16,
			base: base,
			code: '002',
			is_retention: 0,
			name: 'IVA 16%',
			rate: 0.16,
			type: 'rate',
			created: new Date()
		});
		this.updateTotal();
	}

	addIva8()
	{
		if (!this.taxes_item) return;
		let base = this.taxes_item.purchase_detail.unitary_price * this.taxes_item.purchase_detail.qty;
		this.taxes_item.taxes.push({
			id: 0,
			purchase_detail_id: this.taxes_item.purchase_detail.id || 0,
			amount: base * 0.08,
			base: base,
			code: '002',
			is_retention: 0,
			name: 'IVA 8%',
			rate: 0.08,
			type: 'rate',
			created: new Date()
		});
		this.updateTotal();
	}

	addIeps8()
	{
		if (!this.taxes_item) return;
		let base = this.taxes_item.purchase_detail.unitary_price * this.taxes_item.purchase_detail.qty;
		this.taxes_item.taxes.push({
			id: 0,
			purchase_detail_id: this.taxes_item.purchase_detail.id || 0,
			amount: base * 0.08,
			base: base,
			code: '003',
			is_retention: 0,
			name: 'IEPS 8%',
			rate: 0.08,
			type: 'rate',
			created: new Date()
		});
		this.updateTotal();
	}

	addIsr125()
	{
		if (!this.taxes_item) return;
		let base = this.taxes_item.purchase_detail.unitary_price * this.taxes_item.purchase_detail.qty;
		this.taxes_item.taxes.push({
			id: 0,
			purchase_detail_id: this.taxes_item.purchase_detail.id || 0,
			amount: base * 0.0125,
			base: base,
			code: '001',
			is_retention: 1,
			name: 'ISR 1.25%',
			rate: 0.0125,
			type: 'rate',
			created: new Date()
		});
		this.updateTotal();
	}

	removeTax(index: number)
	{
		if (!this.taxes_item) return;
		this.taxes_item.taxes.splice(index, 1);
		this.updateTotal();
	}

	getTaxesTotal(pdi: PurchaseDetailInfo): number
	{
		if (!pdi.taxes || pdi.taxes.length === 0) return 0;
		return pdi.taxes.reduce((sum, tax) => {
			return sum + (tax.is_retention ? -tax.amount : tax.amount);
		}, 0);
	}

	showEditPriceModal(pdi: PurchaseDetailInfo)
	{
		this.edit_price_item = pdi;
		this.edit_price_value = pdi.purchase_detail.unitary_price;
		this.show_edit_price_modal = true;
	}

	saveEditedPrice()
	{
		if (!this.edit_price_item) return;

		this.is_loading = true;

		this.subs.sink = this.rest.updatePath('edit_purchase_detail_price', {
			purchase_detail_id: this.edit_price_item.purchase_detail.id,
			unitary_price: this.edit_price_value
		}).subscribe({
			next: () =>
			{
				this.edit_price_item.purchase_detail.unitary_price = this.edit_price_value;
				this.updateTotal();
				this.show_edit_price_modal = false;
				this.edit_price_item = null;
				this.is_loading = false;
				this.showSuccess('Precio actualizado correctamente');
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	showEditQtyModal(pdi: PurchaseDetailInfo)
	{
		this.edit_qty_item = pdi;
		this.edit_qty_value = pdi.purchase_detail.qty;
		this.edit_qty_original_value = pdi.purchase_detail.qty;
		this.show_edit_qty_modal = true;
	}

	saveEditedQty()
	{
		if (!this.edit_qty_item) return;

		let diff = this.edit_qty_value - this.edit_qty_original_value;

		// Check if batch details are required
		let needsBatchDetails = this.purchase_info.purchase.stock_status === 'ADDED_TO_STOCK'
			&& this.edit_qty_item.item.batch_option
			&& this.edit_qty_item.item.batch_option !== 'NONE'
			&& diff !== 0;

		if (needsBatchDetails)
		{
			// Fetch existing batch records for this purchase_detail
			this.is_loading = true;
			this.subs.sink = this.rest.batch_record.search({
				eq: { purchase_detail_id: this.edit_qty_item.purchase_detail.id, is_current: 1 }
			}).subscribe({
				next: (response) => {
					this.existing_batch_records = response.data;
					this.is_loading = false;

					// Show batch entry modal
					this.edit_qty_diff = Math.abs(diff);
					this.edit_qty_is_increase = diff > 0;
					this.edit_qty_batch_rows = [{ qty: 0, batch: '', expiration_date: '' }];
					this.show_edit_qty_modal = false;
					this.show_edit_qty_batch_modal = true;
				},
				error: (error) => {
					this.is_loading = false;
					this.showError(error);
				}
			});
		}
		else
		{
			this.submitEditedQty(null);
		}
	}

	submitEditedQty(batch_details: any)
	{
		if (!this.edit_qty_item) return;

		this.is_loading = true;

		let payload: any = {
			purchase_detail_id: this.edit_qty_item.purchase_detail.id,
			qty: this.edit_qty_value
		};

		if (batch_details)
		{
			payload.batch_details = batch_details;
		}

		this.subs.sink = this.rest.updatePath('edit_purchase_detail_qty', payload).subscribe({
			next: () =>
			{
				this.edit_qty_item.purchase_detail.qty = this.edit_qty_value;
				this.updateTotal();
				this.show_edit_qty_modal = false;
				this.show_edit_qty_batch_modal = false;
				this.existing_batch_records = [];
				this.edit_qty_item = null;
				this.is_loading = false;
				this.showSuccess('Cantidad actualizada correctamente');
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}

	addEditQtyBatchRow()
	{
		this.edit_qty_batch_rows.push({ qty: 0, batch: '', expiration_date: '' });
	}

	getRemainingQtyToAssign(): number
	{
		return this.edit_qty_diff - this.getTotalEditQtyBatch();
	}

	addBatchFromExisting(br: Batch_Record)
	{
		let remaining = this.getRemainingQtyToAssign();
		if (remaining <= 0) return;

		// For decreasing qty, use minimum of remaining needed and available in batch
		// For increasing qty, use the remaining needed (we're adding stock, not limited by existing)
		let qtyToAdd = this.edit_qty_is_increase ? remaining : Math.min(remaining, br.qty);

		if (qtyToAdd <= 0) return;

		// Check if we already have a row with this batch/expiration, if so add to it
		let existingRow = this.edit_qty_batch_rows.find(row =>
			row.batch === br.batch && row.expiration_date === (br.expiration_date || '')
		);

		if (existingRow)
		{
			// Update existing row qty
			let maxAdd = this.edit_qty_is_increase ? remaining : Math.min(remaining, br.qty);
			existingRow.qty += maxAdd;
		}
		else
		{
			// If there's an empty first row with qty 0, replace it
			if (this.edit_qty_batch_rows.length === 1 &&
				this.edit_qty_batch_rows[0].qty === 0 &&
				!this.edit_qty_batch_rows[0].batch &&
				!this.edit_qty_batch_rows[0].expiration_date)
			{
				this.edit_qty_batch_rows[0] = {
					qty: qtyToAdd,
					batch: br.batch || '',
					expiration_date: br.expiration_date || ''
				};
			}
			else
			{
				this.edit_qty_batch_rows.push({
					qty: qtyToAdd,
					batch: br.batch || '',
					expiration_date: br.expiration_date || ''
				});
			}
		}
	}

	removeEditQtyBatchRow(index: number)
	{
		if (this.edit_qty_batch_rows.length > 1)
		{
			this.edit_qty_batch_rows.splice(index, 1);
		}
	}

	getTotalEditQtyBatch(): number
	{
		return this.edit_qty_batch_rows.reduce((sum, row) => sum + (row.qty || 0), 0);
	}

	validateEditQtyBatchEntries(): boolean
	{
		let total = this.getTotalEditQtyBatch();
		if (total !== this.edit_qty_diff)
		{
			this.showError(`La cantidad total debe ser ${this.edit_qty_diff}, actualmente es ${total}`);
			return false;
		}

		let batch_option = this.edit_qty_item?.item.batch_option;

		for (let row of this.edit_qty_batch_rows)
		{
			if (row.qty <= 0)
			{
				this.showError('La cantidad debe ser mayor a 0');
				return false;
			}

			if ((batch_option === 'BATCH_ONLY' || batch_option === 'BATCH_AND_EXPIRATION') && !row.batch)
			{
				this.showError('El código de lote es requerido');
				return false;
			}

			if ((batch_option === 'EXPIRATION_ONLY' || batch_option === 'BATCH_AND_EXPIRATION') && !row.expiration_date)
			{
				this.showError('La fecha de caducidad es requerida');
				return false;
			}
		}
		return true;
	}

	submitEditQtyBatch()
	{
		if (!this.validateEditQtyBatchEntries())
		{
			return;
		}

		let batch_option = this.edit_qty_item?.item.batch_option;

		let batch_details = {
			quantities: this.edit_qty_batch_rows.map(row => {
				let q: any = { qty: row.qty };
				if (batch_option === 'BATCH_ONLY' || batch_option === 'BATCH_AND_EXPIRATION')
				{
					q.batch = row.batch;
				}
				if (batch_option === 'EXPIRATION_ONLY' || batch_option === 'BATCH_AND_EXPIRATION')
				{
					q.expiration_date = row.expiration_date;
				}
				return q;
			})
		};

		this.submitEditedQty(batch_details);
	}

	cancelEditQtyBatch()
	{
		this.show_edit_qty_batch_modal = false;
		this.edit_qty_batch_rows = [];
		this.existing_batch_records = [];
		this.edit_qty_item = null;
	}
}
